import store from "@/store";
import { CHANNEL_TYPES, COLLAPSE_MEMBER_COUNT } from '@/common/constants/channel';
import { ROOM_ICON_ID_MAP } from '@/common/constants/room';
import markdownToHtml from '_lib/MarkdownToHtml';
// 频道列表影响高度的改动，需要同步修改SCROLLER_ITEM_SIZE，否则频道列表高度会有问题
// 如果有新增的key，需要修改flattenChannels函数中size的计算方式
export const SCROLLER_ITEM_SIZE = {
  header: 191,
  header_without_level: 128,
  group: 30,
  group_split: 9,
  channel: 34,
  channel_promise: 16,
  channel_game: 16,
  user: 32,
  top_bar: 52,
  collapse_text_channel: 34,
  collapse_audio_channel: 70,
  collapse_users: 32,
  custom: 34,
  anc: 34,
  top_channel_split: 8,
  activity_btn: 34,
  activity_interval_container_without_content: 102,
  activity_interval_dots: 10,
  last_one_padding: 30,
  activity_interval_container_row: 21,
  guidance: 32,
  tool_list: 30,
  normal_room_info: 128, // 正常展示下房间数据的高度
  simple_room_info: 40, // 简化展示下房间数据的高度 场景： 房间活动/公告展示时
  tool_split_line: 13,
}
function handlePushChannel (data, list) {
  const channel = data.data
  if (!channel) return false
  if (channel.not_show) {
    return false  
  }
  list.push(data)
  return true
}

export function getFlattenChannels(channels, cur_room_data, needSplitIndex = 0) {
  if (!channels || !channels.length) {
    return []
  }
  let flatChannels = [{
    channel_id: '-999',
    type: 'header',
    size: cur_room_data && cur_room_data.room_setting && cur_room_data.room_setting.show_room_level 
    ? SCROLLER_ITEM_SIZE['header']
    : SCROLLER_ITEM_SIZE['header_without_level']
  }]
  channels.forEach((channel, index) => {
    // 如果是频道组并且没被折叠的话，将channel_list push进去
    if (channel.channel_type === CHANNEL_TYPES.group) {
      const channel_list = channel.channel_list || []
      const isPush = handlePushChannel({
        channel_id: channel.channel_id,
        type: 'group',
        size: getFlattenGroupSize(channel, index > needSplitIndex),
        data: channel,
        originGroupIndex: index,
      }, flatChannels)
      if (isPush && channel_list.length && !store.getters.hide_channel_group_ids[cur_room_data.room_id]?.includes(channel.channel_id)) {
        channel_list.forEach(sub_channel => {
          handlePushChannel({
            channel_id: sub_channel.channel_id,
            type: 'channel',
            size: getFlattenChannelSize(sub_channel),
            data: sub_channel,
          }, flatChannels)
        })
      }
    } else {
      handlePushChannel({
        channel_id: channel.channel_id,
        type: 'channel',
        size: getFlattenChannelSize(channel),
        data: channel,
      }, flatChannels)
    }
  })
  return flatChannels
}

// 获取非频道组的高度
export function getFlattenChannelSize(channel) {
  let size = SCROLLER_ITEM_SIZE['channel']
  const channelId = channel.channel_id;
  if (store.getters.manually_expanded_channel_ids[channelId] === 'on') {
    size += SCROLLER_ITEM_SIZE['user'] * (channel.members?.length || 0)
  } else if (store.getters.manually_expanded_channel_ids[channelId] === 'off') {
    size += SCROLLER_ITEM_SIZE['collapse_users']
  } else {
    if (store.getters.cur_channel_data.channel_id === channelId) {
      size += SCROLLER_ITEM_SIZE['user'] * (channel.members?.length || 0)
    } else if (channel.members?.length >= COLLAPSE_MEMBER_COUNT) {
      size += SCROLLER_ITEM_SIZE['collapse_users']
    }
    else {
      size += SCROLLER_ITEM_SIZE['user'] * (channel.members?.length || 0)
    }
  }

  if (channel.promise && channel.promise.length > 0) {
    size += SCROLLER_ITEM_SIZE['channel_promise']
  }
  return size
}

/**
 * 分位两种，折叠和非折叠
 * 1. 折叠高度 = Base + 文字频道数量 * 34 + 自己所在语音频道数 * 66 + 折叠语音用户数 > 0 ? 32 : 0
 * 2. 非折叠高度 = Base
 * Base高度 = 分组 + 分组分割线
 * @param {*} groupChannel 
 * @returns 频道组的高度
 */
export function getFlattenGroupSize(groupChannel, needSplit = true){
  const { channel_id } = groupChannel
  let size = SCROLLER_ITEM_SIZE['group'] + (needSplit ? SCROLLER_ITEM_SIZE['group_split'] : 0) // 写死的高度
  const isHide = store.getters.hide_channel_all_group_ids.includes(channel_id)
  if (isHide) {
    const { collapseData } = groupChannel
    if(!collapseData) {
      return size
    }
    const { actives, others, others_count } = collapseData

    const activeSize = actives.reduce((pre, cur) => {
      const curSize = CHANNEL_TYPES.only_text_types.includes(cur.channel_type) ? SCROLLER_ITEM_SIZE['collapse_text_channel'] : SCROLLER_ITEM_SIZE['collapse_audio_channel']
      return pre + curSize
    }, 0)
    
    const otherSize = (others.length || others_count) ? SCROLLER_ITEM_SIZE['collapse_users'] : 0
    size += activeSize + otherSize
  }
  return size;
}

/**
 * 计算隐藏语音列表高度
 * @param {*} list 语音频道列表
 * @param {*} expend 是否为展开状态
 */
export function getHideChannelSize(list, expend) {
  const PADDING_TOP = 9;
  const BTN_HEIGHT = 46;
  let size = PADDING_TOP + BTN_HEIGHT;
  if (expend) {
    /**
     * 计算全部的频道高度
     */
    for (let i = 0; i < list.length; i++) {
      const channelSize = getFlattenChannelSize(list[i]);
      size += channelSize;
    }
  } else {
    /**
     * 计算折叠的频道高度
     */
    const collapseList = list.filter((item) => item.members && item.members.length > 0);
    size += SCROLLER_ITEM_SIZE['collapse_audio_channel'] * collapseList.length;
  }
  return size;
}

/**
 * 获取房间活动轮播图的高度
 * @returns 轮播图组件高度
 */
export function getRoomActIntervalSize(actList, rows){
  const isNeedDots = actList.length > 1

  let contentHeight = SCROLLER_ITEM_SIZE['activity_interval_container_row'] * rows

  return  (    
    SCROLLER_ITEM_SIZE['activity_interval_container_without_content'] + 
    (isNeedDots ? SCROLLER_ITEM_SIZE['activity_interval_dots'] : 0) + 
    contentHeight
  )
}

// 获取房间公告Banner内容区高度
export function getRoomAncBannerHeight() {
  if(!store.getters.cur_room_data.anc) return 0
  const container = document.createElement('div');
  container.style.visibility = 'hidden';
  container.style.position = 'absolute';
  container.style.top = '-9999px';
  container.style.wordBreak ='break-all';
  container.style.left = '-9999px';
  document.body.appendChild(container);

  const mdContent = store.getters.cur_room_data.anc.anc

  container.innerHTML = markdownToHtml(
    mdContent,
    false,
    true
  );
  const allPElements = container.querySelectorAll('p');
  const width = store.getters.channel_sidebar_width - 16 - 16 // 减去wrapper和container的padding
  const styleObj = {
    fontSize: '14px',
    fontWeight: '700',
    width: `${width}px`,
    display: '-webkit-box',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    lineHeight: '21px',
  }
  setElementStyle(allPElements || [], styleObj)

  const HEADER_HEIGHT = 32; // banner的header的高度
  const BUTTON_HEIGHT = 30; // 查看详情的按钮高度
  const GAP = 8; // 按钮和公告之间的间距
  const BOTTOM_PADDING = 8; // 底部padding

  const CONTENT_MAX_HEIGHT = 42; // 内容区最大高度

  const CONTENT_HEIGHT = Math.max(
    Math.min(container.getBoundingClientRect().height, CONTENT_MAX_HEIGHT),
    21
  );

  document.body.appendChild(container);

  const result =
  CONTENT_HEIGHT +
    HEADER_HEIGHT +
    BUTTON_HEIGHT +
    BOTTOM_PADDING +
    GAP

  container.remove();
  return result;
}

function setElementStyle (elements, styleObj) {
  elements.forEach(el => {
    Object.assign(el.style, styleObj); // 使用 Object.assign 复制样式
  });
}

/**
 * 
 * @param {*} actList 需要展示的活动列表
 */
export function getRoomActContentRows(actList) {
  const MAX_ROW_COUNT = 2
  const MAX_HEIGHT = SCROLLER_ITEM_SIZE['activity_interval_container_row'] * MAX_ROW_COUNT
  let rows = 1

  const container = document.createElement('div');
  container.style.visibility = 'hidden';
  container.style.position = 'absolute';
  container.style.top = '-9999px';
  container.style.wordBreak ='break-all';
  container.style.left = '-9999px';
  document.body.appendChild(container);

  const styleObj = {
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontSize: '14px',
    fontWeight: 700,
    lineHeight: '20px',
    letterSpacing: '0.14px',
  };

  for(let i = 0; i < actList.length; i++) {
    const actData = actList[i]
    const mdContent = `${actData.title} ${markdownToHtml(
        actData.text ?? '',
        false,
        true
      )}`;
    container.innerHTML = markdownToHtml(
      mdContent,
      false,
      true
    );
    const allPElements = container.querySelectorAll('p');

    setElementStyle(allPElements || [], styleObj)

    let curRow = Math.ceil(
      Math.min(container.getBoundingClientRect()?.height, MAX_HEIGHT) /
        SCROLLER_ITEM_SIZE['activity_interval_container_row']
    );
    if(curRow >= MAX_ROW_COUNT) {
      rows = curRow
      break;
    }
  }
  container.remove();
  return rows
}

// 获取ChannelSidebar的RoomInfo高度
export function getChannelSidebarRoomInfoHeight(data) {
  const {
    showActivityInterval,
    showAncBanner,
  } = data
  if(showActivityInterval || showAncBanner) {
    return SCROLLER_ITEM_SIZE['simple_room_info']
  } else {
    return SCROLLER_ITEM_SIZE['normal_room_info']
  }
}

// 获取ChannelSidebar的Toolbar高度
export function getChannelSidebarToolbarHeight(data) {
  const TOOL_LIST_HEIGHT = SCROLLER_ITEM_SIZE['tool_list'] + 8 // 工具栏列表高度 + margin-top 30 + 8
  return TOOL_LIST_HEIGHT
}

// 获取ChannelSidebar的BannerPanel高度
export function getChannelSidebarBannerPanelHeight(data) {
  const {
    showActivityInterval,
    showActivities,
    actContentRows,
    showAncBanner,
  } = data

  if(showActivityInterval) {
    return getRoomActIntervalSize(showActivities, actContentRows) + SCROLLER_ITEM_SIZE['tool_split_line']
  } else if(showAncBanner) {
    return getRoomAncBannerHeight() + SCROLLER_ITEM_SIZE['tool_split_line']
  } else {
    return 0
  }
}

// 获取ChannelSidebar的RoomGuidance高度
export function getChannelSidebarRoomGuidanceHeight(data) {
  const {
    showGuidanceBtn,
  } = data

  if(showGuidanceBtn) {
    // 分割线高度 + 引导按钮高度
    return SCROLLER_ITEM_SIZE['guidance'] + SCROLLER_ITEM_SIZE['tool_split_line']
  } else {
    return 0
  }
}

export function getChannelSidebarBottomSplitHeight(data) {
  const showRoomInfo = data.showActivityInterval || data.showAncBanner
  return data.showGuidanceBtn || !showRoomInfo ? SCROLLER_ITEM_SIZE['tool_split_line'] : 0
}
/**
 * 获取整个ChannelSidebar顶部的高度 
 * @description 相当于原先initVirtualHeaderChannels的高度计算版本
 * @param {object} data 计算所需要的Vue状态
 * @returns 
 */
export function getChannelSidebarStaticHeight(data) {
  const roomInfoHeight = getChannelSidebarRoomInfoHeight(data)
  const toolbarHeight = getChannelSidebarToolbarHeight(data)
  const bannerPanelHeight = getChannelSidebarBannerPanelHeight(data)
  const roomGuidanceHeight = getChannelSidebarRoomGuidanceHeight(data)
  const bottomSplitHeight = getChannelSidebarBottomSplitHeight(data)
  const res = roomInfoHeight + toolbarHeight + bannerPanelHeight + roomGuidanceHeight + bottomSplitHeight
  return res
}
